import { useTheme } from '@evaneos/b2b-ui';
import { NavLink } from 'react-router-dom';
import type { ComponentProps, PropsWithChildren } from 'react';

type Props = ComponentProps<typeof NavLink> & { disabled?: boolean };

export const AppointmentNavLink = ({ disabled, ...props }: PropsWithChildren<Props>) => {
    const theme = useTheme();

    const baseStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        height: 48,
        padding: '0 16px',
        fontSize: '1.4rem',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.text.primary,
        textDecoration: 'none',
        borderBottom: '2px solid transparent',
    } as const;

    if (disabled) {
        return (
            <a
                aria-disabled="true"
                tabIndex={-1}
                style={{ ...baseStyle, opacity: 0.38, cursor: 'default' }}
            >
                {props.children}
            </a>
        );
    }

    return (
        <NavLink
            style={({ isActive }) => ({
                ...baseStyle,
                ...(isActive && {
                    fontWeight: 'bold',
                    color: theme.palette.primary.main,
                    borderBottomColor: theme.palette.primary.main,
                }),
            })}
            {...props}
        />
    );
};
